import React, { useState } from 'react'
import { Container, Top } from '../styles'
import { TabContainer } from './styles'
import { DefaultAdminPage } from '../../DefaultPages'
import { Breadcrumbs, Tab } from '../../../components'
import { ConfigurationTabs } from '../../../constants/order'
import TermAndConditionScreen from './TermAndConditionScreen'
import BankSlipConfigScreen from './BankSlipConfigScreen'

const Configuration = () => {
  const [tabName, setTabName] = useState(ConfigurationTabs.TERMS_AND_CONDITIONS)

  return (
    <DefaultAdminPage page="configuration">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <TabContainer>
          <Tab>
            <Tab.Item
              name="tabName"
              label="Termos de aceite"
              onClick={() => setTabName(ConfigurationTabs.TERMS_AND_CONDITIONS)}
              checked={tabName === ConfigurationTabs.TERMS_AND_CONDITIONS}
            />
            <Tab.Item
              name="tabName"
              label="Configurações de boleto"
              onClick={() => setTabName(ConfigurationTabs.BANK_SLIP_CONFIG)}
              checked={tabName === ConfigurationTabs.BANK_SLIP_CONFIG}
            />
          </Tab>
        </TabContainer>
        {tabName === ConfigurationTabs.TERMS_AND_CONDITIONS && (
          <TermAndConditionScreen />
        )}
        {tabName === ConfigurationTabs.BANK_SLIP_CONFIG && (
          <BankSlipConfigScreen />
        )}
      </Container>
    </DefaultAdminPage>
  )
}

export default Configuration
